import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-bottom">
        <p>{t("footer.copy")}</p>
      </div>
    </footer>
  );
}
